'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _caligramReact = require('caligram-react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RegionPicker = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(RegionPicker, _React$Component);

  function RegionPicker(props) {
    (0, _classCallCheck3.default)(this, RegionPicker);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RegionPicker.__proto__ || (0, _getPrototypeOf2.default)(RegionPicker)).call(this, props));

    _this.state = {
      visible: false
    };
    return _this;
  }

  (0, _createClass3.default)(RegionPicker, [{
    key: 'toggle',
    value: function toggle() {
      this.setState(function (state) {
        return (0, _extends3.default)({}, state, { visible: !state.visible });
      });
    }
  }, {
    key: 'handleKeyPress',
    value: function handleKeyPress(ev) {
      if (ev.charCode === 13) {
        this.toggle();
      }
    }
  }, {
    key: 'handleClick',
    value: function handleClick(item) {
      this.setState(function (state) {
        return (0, _extends3.default)({}, state, { visible: false });
      });
      this.props.action.call(this, item);
    }
  }, {
    key: 'dropdownView',
    value: function dropdownView() {
      return _react2.default.createElement(_caligramReact.SelectionList, { available: this.props.regions, selected: this.props.selectedRegions, iconSelected: 'checkmark', action: this.handleClick.bind(this), clear: this.props.clear, clearText: 'n\u2019importe o\xF9', labelKey: 'label', groupKey: null });
    }
  }, {
    key: 'render',
    value: function render() {
      var selectedRegions = this.props.selectedRegions;


      return _react2.default.createElement(
        _caligramReact.Popover,
        {
          visible: this.state.visible,
          dropdownView: this.dropdownView(),
          clickOverlay: this.toggle.bind(this)
        },
        _react2.default.createElement(
          'span',
          { className: 'RegionPicker', onClick: this.toggle.bind(this), onKeyPress: this.handleKeyPress.bind(this), tabIndex: 0 },
          _react2.default.createElement(
            'span',
            { className: 'region' },
            selectedRegions[0] ? selectedRegions[0].label : 'n’importe où'
          ),
          _react2.default.createElement(_caligramReact.Icon, { name: 'chevronDown' })
        )
      );
    }
  }]);
  return RegionPicker;
}(_react2.default.Component), _class.propTypes = {
  action: _react.PropTypes.func,
  clear: _react.PropTypes.func,
  regions: _react.PropTypes.array,
  selectedRegions: _react.PropTypes.array
}, _temp);
exports.default = RegionPicker;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/RegionPicker.js
// module id = 1085
// module chunks = 0